/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setMvPageNav.js
 * 
 * TOPページMV用スクリプト
 * 
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ストーカー範囲指定
 */
const mouseTransformArea = document.querySelectorAll(".nav-list a");

/**
 * ストーカー範囲内で追従
 */
function setMvPageNavMouseStalker() {
    for (let i = 0; i < mouseTransformArea.length; i++) {
        /**
         * 範囲内ホバー時
         */
        mouseTransformArea[i].addEventListener("mouseover", (e) => {
            let currentArea = e.currentTarget;
            let currentAreaCircle = currentArea.querySelector('.list-circle');
            currentAreaCircle.classList.add('move-circle');
            document.getElementById('site-mv').classList.add('has_shadow');

            /**
             * 範囲内"offsetX, offsetY"移動
             */
            mouseTransformArea[i].addEventListener("mousemove", (e) => {
                currentAreaCircle.style.transform = `translate(${e.offsetX}px, ${e.offsetY}px)`;
            })
        });

        /**
         * 範囲外ホバー時
         */
        mouseTransformArea[i].addEventListener("mouseleave", (e) => {
            let currentArea = e.currentTarget;
            let currentAreaCircle = currentArea.querySelector('.list-circle');
            currentAreaCircle.classList.remove('move-circle');
            currentAreaCircle.style.transform = `translate(0px, 0px)`;
            document.getElementById('site-mv').classList.remove('has_shadow');
        });
    }
}

export { setMvPageNavMouseStalker }